import * as React from 'react';
import { SvgIconProps } from 'src/types/icons/SvgIcon';

export function UploadIcon({ title, color, width, height, size, ...props }: SvgIconProps): React.ReactElement {
    return (
        <svg {...props} width={width ?? size ?? 21} height={height ?? size ?? 21} viewBox='0 0 20 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
            {title && <title>{title}</title>}
            <path
                d='M10.0046 11.9053V6.06725M10.0046 6.06725L12.5993 8.66194M10.0046 6.06725L7.40992 8.66194M5.4639 14.5C4.53797 14.501 3.64201 14.1719 2.93692 13.5717C2.23184 12.9715 1.76383 12.1396 1.61693 11.2254C1.47003 10.3112 1.65387 9.3746 2.13544 8.58375C2.61701 7.7929 3.36476 7.19965 4.24439 6.91052C4.01839 5.75257 4.25197 4.55212 4.89565 3.56339C5.53932 2.57465 6.54257 1.87526 7.69292 1.61333C8.84328 1.3514 10.0504 1.5475 11.0587 2.16009C12.067 2.77268 12.7973 3.75367 13.0949 4.89531C13.555 4.74567 14.0478 4.72766 14.5177 4.84333C14.9875 4.959 15.4156 5.20374 15.7537 5.5499C16.0917 5.89607 16.3263 6.32986 16.4308 6.80229C16.5353 7.27473 16.5057 7.76697 16.3452 8.22344C17.0532 8.49389 17.6443 9.00366 18.0158 9.66431C18.3873 10.325 18.5158 11.0948 18.3791 11.8403C18.2424 12.5858 17.849 13.26 17.2672 13.7458C16.6854 14.2316 15.9519 14.4984 15.194 14.5H5.4639Z'
                stroke={color ?? 'currentColor'}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
}
